export const DELIMITER = ";";

export const buildQueryValue = (value: string | readonly string[]): string => {
    if (Array.isArray(value)) {
        return `${value.join(DELIMITER)}`;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- we know value is a string after Array.isArray check
    return value as string;
};

export const parseQueryValue = (str?: string | null): string[] =>
    !!str
        ? str.split(DELIMITER) // str !== undefined & str.length > 0
        : [];

export const buildQueryParameters = (params: Record<string, string | string[] | undefined>): string => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        queryParams.set(key, buildQueryValue(value ?? ""));
    });
    return queryParams.toString();
};

export const buildUrlFromQueryParam = (path: string, params: Record<string, string | string[] | undefined>): string => {
    const queryString = buildQueryParameters(params);
    return queryString ? `${path}?${queryString}` : path;
};
